/* ===== TRKVLT "Add"-style order bumps + product-global fix ===== */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Set the add-on variant-ID globals from #main-content data attributes.
     The theme only populated these during AJAX navigation, so on a fresh /
     direct / ad page load they were undefined and add-on clicks silently
     failed to reach the cart. This runs on initial load and on every
     trkvltPageInit (which the AJAX nav layer also calls). */
  function setProductGlobals() {
    var main = document.getElementById('main-content');
    if (!main) return;
    if (main.dataset.stemsId) window.PRODUCT_STEMS_ID = Number(main.dataset.stemsId) || 0;
    if (main.dataset.unlimitedId) window.PRODUCT_UNLIMITED_ID = Number(main.dataset.unlimitedId) || 0;
    if (main.dataset.productId) window.CURRENT_PRODUCT_ID = Number(main.dataset.productId) || 0;
  }

  /* --- Cart drawer: inject bump rows below the cart items --- */
  function injectDrawerBumps() {
    var body = document.getElementById('cart-body');
    if (!body) return;
    fetch(ROOT + '?section_id=cart-bumps')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var bumps = Array.prototype.slice.call(doc.querySelectorAll('.cart-bump'));
        var container = document.getElementById('cart-bumps-container');
        if (!bumps.length) { if (container) container.remove(); return; }
        if (!container) {
          container = document.createElement('div');
          container.id = 'cart-bumps-container';
          body.parentNode.insertBefore(container, body.nextSibling);
        }
        container.innerHTML = '<div class="cart-bumps-title">Complete your order</div>';
        bumps.forEach(function (b) { container.appendChild(b); });
      })
      .catch(function () {});
  }

  /* Monkey-patch renderCartDrawer so bumps refresh on every cart render. */
  function patchRender() {
    if (typeof window.renderCartDrawer !== 'function') { setTimeout(patchRender, 200); return; }
    if (window._trkvltBumpsPatched) return;
    window._trkvltBumpsPatched = true;
    var orig = window.renderCartDrawer;
    window.renderCartDrawer = function (cart) {
      orig(cart);
      injectDrawerBumps();
    };
  }

  /* Re-apply globals + product-page pills on AJAX navigation, which the
     theme drives through trkvltPageInit. */
  function patchPageInit() {
    if (typeof window.trkvltPageInit !== 'function') { setTimeout(patchPageInit, 200); return; }
    if (window._trkvltPageInitPatched) return;
    window._trkvltPageInitPatched = true;
    var orig = window.trkvltPageInit;
    window.trkvltPageInit = function () {
      setProductGlobals();
      orig();
      enhanceProductBumps();
    };
  }

  /* Add a bump to the cart, then re-render drawer + sync product page state. */
  window.trkvltAddBump = function (variantId, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function () { return fetch(ROOT + 'cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (typeof window.updateCartBadge === 'function') window.updateCartBadge(cart.item_count);
        if (typeof window.renderCartDrawer === 'function') window.renderCartDrawer(cart);
        syncProductPageAddon(variantId, true);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Add'; } });
  };

  function syncProductPageAddon(variantId, checked) {
    var s = document.querySelector('input[name="addon1"]');
    var u = document.querySelector('input[name="addon2"]');
    if (s && String(window.PRODUCT_STEMS_ID) === String(variantId)) {
      s.checked = checked;
      if (s.closest('.pd-addon')) s.closest('.pd-addon').classList.toggle('selected', checked);
    }
    if (u && String(window.PRODUCT_UNLIMITED_ID) === String(variantId)) {
      u.checked = checked;
      if (u.closest('.pd-addon')) u.closest('.pd-addon').classList.toggle('selected', checked);
    }
    if (typeof window.updatePrice === 'function') window.updatePrice();
    if (typeof window.updateTrkvltCheckout === 'function') window.updateTrkvltCheckout();
    if (typeof window.trkvltUpdateNativeSwap === 'function') window.trkvltUpdateNativeSwap();
    document.querySelectorAll('.pd-addon .pd-addon-pill').forEach(function (pill) {
      var box = pill.closest('.pd-addon').querySelector('input[type="checkbox"]');
      pill.textContent = box && box.checked ? 'Added ✓' : '+ Add';
      pill.classList.toggle('added', !!(box && box.checked));
    });
  }

  /* --- Product page: turn the add-on checkboxes into "Add / Added" pills --- */
  function enhanceProductBumps() {
    document.querySelectorAll('.pd-addon').forEach(function (addon) {
      if (addon.dataset.enhanced) return;
      var input = addon.querySelector('input[type="checkbox"]');
      if (!input) return;
      addon.dataset.enhanced = '1';
      var pill = document.createElement('span');
      pill.className = 'pd-addon-pill';
      addon.appendChild(pill);
      function refresh() {
        pill.textContent = input.checked ? 'Added ✓' : '+ Add';
        pill.classList.toggle('added', input.checked);
      }
      input.addEventListener('change', refresh);
      refresh();
    });
  }

  function init() {
    setProductGlobals();
    patchRender();
    patchPageInit();
    enhanceProductBumps();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
